import clsx from 'clsx';
import React from 'react';
import Button from '../../components/Button';
import { useButtonSizeBigger } from '../../utils/buttonSizes';

interface OnboardingViewProps {
  otherClasses?: string;
}

const OnboardingView: React.FC<OnboardingViewProps> = ({ otherClasses }) => {
  const onboardingViewClasses = clsx(
    otherClasses,
    'flex flex-1 flex-col items-center gap-10 pt-12 md:pt-32 lg:pt-28',
  );
  const sizes = useButtonSizeBigger();
  return (
    <div className={onboardingViewClasses} data-testid="onboarding-view">
      <div className="flex flex-col items-center gap-2.5 text-center">
        <img
          src="/assets/images/logo.png"
          alt="logo"
          className="h-85 w-69 md:h-100 md:w-20 lg:h-150 lg:w-121"
        />
        <h4 className="font-inter-variable font-bold">Welcome to</h4>
        <h1 className="text-brand-byzantine font-bold">
          EHS{' '}
          <span className="text-neutral-tones-text font-light">Navigator</span>
        </h1>
      </div>
      <div className="flex flex-1 flex-col justify-center">
        <div className="flex flex-col items-stretch gap-5">
          <Button size={sizes} href="/sign-up">
            Create New Account
          </Button>
          <Button size={sizes} variant="secondary" href="/sign-in">
            Sign In
          </Button>
        </div>
      </div>
    </div>
  );
};

export default OnboardingView;
